import { DocumentCloser } from "../types";
import { closeAvailable } from "../shared/closeSupport";

// Closing the document after a check in: WordApi 1.5's Document.close, which Word on
// the web does not implement. Closed WITHOUT saving -- the content has just been
// published to Jylo, and a save would aim at the read-only draft URL the document was
// opened from, which is the very prompt closing is meant to spare the user.

export const wordCloser: DocumentCloser = {
  isAvailable: () => closeAvailable("WordApi", "1.5", { web: false }),
  close: () =>
    Word.run(async (context) => {
      context.document.close(Word.CloseBehavior.skipSave);
      await context.sync();
    }),
};
